import { z } from "zod"

const emailLogSearchSchema = z.object({
  search: z.string().optional(),
  kind: z.string().optional(),
  status: z.string().optional(),
})

type EmailLogSearch = z.infer<typeof emailLogSearchSchema>

export { emailLogSearchSchema }
export type { EmailLogSearch }
